import { Ok, Result } from 'ts-res';
import { KameleoonError } from 'src/kameleoonError';
import { Parser } from 'src/utilities';
import { EvaluationDataType, MatchType } from 'src/targeting/types';
import { ConditionDataType, ICondition } from './types';
import { KameleoonLogger } from 'src/logging';

export class VisitorCode implements ICondition {
  private matchType?: MatchType | null;
  private conditionValue?: string | null;

  constructor({ visitorCode, matchType }: ConditionDataType) {
    this.matchType = matchType;
    this.conditionValue = visitorCode;
  }

  public evaluate({
    visitorCode,
  }: EvaluationDataType): Result<boolean, KameleoonError> {
    return Ok(this.checkCondition(visitorCode));
  }

  private checkCondition(visitorCode: string): boolean {
    if (!this.matchType || !this.conditionValue) {
      return false;
    }

    switch (this.matchType) {
      case MatchType.CONTAINS:
        return visitorCode.includes(this.conditionValue);
      case MatchType.EXACT:
        return visitorCode === this.conditionValue;
      case MatchType.REGULAR_EXPRESSION:
        return Parser.parseRegExp(this.conditionValue).test(visitorCode);
      default:
        KameleoonLogger.error`Unexpected comparing operation for VisitorCode condition: ${this.matchType}`;
        return false;
    }
  }
}
